<template>
  <div :class="['warp-history', { show: isShow }]" @click="hide">
    <b-sidebar
      id="sidebar-filter-history"
      :backdrop-variant="variant"
      backdrop
      shadow
      visible
      no-header
      right
    >
      <div class="sidepanel" @click.stop="">
        <div
          class="sticky-top d-flex justify-content-between align-items-center px-3"
        >
          <span class="title-side">Chat Shopee FAQ</span>
          <a href="javascripxt:void(0)" class="closebtn" @click="hide">×</a>
        </div>
        <div class="filter-form border-top pt-2">
          <div class="chat-search-result show-mark">
            <div class="results">
              <div
                v-for="(item, index) in chatList"
                :key="index + 'history'"
                class="msg-row"
              >
                <div class="d-flex justify-content-between ">
                  <p class="name">{{ item.status ?? "" }}</p>
                  <ChatDateTime
                    class="time"
                    :date="getDateByTimeStamp(item.createdTimestamp)"
                  />
                </div>
                <div class="msg_cotainer">
                  <span
                    v-if="item.messageType == 'text'"
                    class="text-nextline"
                    v-html="item.typedContent.text"
                  ></span>

                  <span
                    v-if="item.messageType == 'new_faq'"
                    class="text-nextline"
                    v-html="item.typedContent.opening"
                  >
                  </span>

                  <span v-if="item.messageType == 'faq_unsupported'">
                    FAQ Tigger {{ item.typedContent.triggerSource }}
                  </span>
                </div>
                <div class="border-bottom-custom"></div>
              </div>
              <div
                class="loading-prepare"
                v-if="isLoading && !isLoadingInfinite"
              >
                <img
                  src="@/assets/images/loading-d-dots.gif"
                  alt="loading"
                  class="loading-icon"
                />
              </div>
              <div v-if="chatList.length < 1 && !isLoading" class="reload-chat">
                <div class="text-center">
                  <p>{{ $t("noChat") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-sidebar>
    <ChatBoxModalImage ref="ChatBoxModalImage" :path="path" />
  </div>
</template>

<script>
import ChatBoxModalImage from "@/components/chat/chatBox/modal/ChatBoxModalImage";
import ChatDateTime from "@/components/chat/ChatDateTime";
export default {
  props: {
    messageId: {
      required: true,
      type: String
    }
  },
  components: {
    ChatBoxModalImage,
    ChatDateTime
  },
  data() {
    return {
      modalMessage: "",
      variant: "dark",
      isShow: false,

      chatList: [],
      isLoading: false,
      isLoadingInfinite: false,
      importType: "",
      timer: null,
      total: 0,
      isSubmitted: false,
      path: ""
    };
  },
  methods: {
    getDateByTimeStamp(timestamp) {
      const date = new Date(timestamp * 1000); // ต้องคูณ 1000 ให้เป็น ms

      const pad = n => n.toString().padStart(2, "0");

      const day = pad(date.getDate());
      const month = pad(date.getMonth() + 1); // เดือนเริ่มที่ 0
      const year = date.getFullYear();
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    hide() {
      this.isSubmitted = false;
      this.isShow = false;
    },
    async show() {
      console.log("tata");

      await this.init();
      this.isShow = true;
    },

    async init() {
      this.chatList = [];
      this.total = 0;
      await this.loadHistoryChat();
    },

    async loadHistoryChat() {
      try {
        this.isLoading = true;
        let messageList = this.messageId.split(",");
        let conversationId = messageList[0];
        messageList.splice(0, 1);
        const body = {
          conversationId: conversationId,
          messageIds: messageList,
          userGUID: this.$store.state.chatUserGUIDSelected
        };
        let result = await fetch(
          `${this.$shopeeUrl}/shopee/getChatShopeeHistory`,
          {
            method: "post",
            headers: new Headers(this.$headersChat),
            body: JSON.stringify(body)
          }
        );
        let resultJson = await result.json();
        this.chatList = resultJson.detail.messages ?? [];
        console.log("🚀 ~ loadHistoryChat ~ result:", result);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleMarkText(items, search) {
      let list = items.map(item => {
        let message = item.message.split(search);
        let messageHtml = "";
        if (search) {
          message.forEach((item2, index) => {
            messageHtml += `${item2}${
              index < message.length - 1 ? `<mark>${search}</mark>` : ""
            }`;
          });
        } else messageHtml = item.message;
        return {
          ...item,
          messageHtml: messageHtml
        };
      });

      return list;
    },
    scrollMethod($state) {
      setTimeout(async () => {
        if (this.chatList.length > 0) {
          this.filter.messageId = this.chatList[
            this.chatList.length - 1
          ].messageId;
        }
        this.isLoadingInfinite = true;
        this.submitSearch(true, $state);
      }, 500);
    },
    selectSearchMsg(item, index) {
      if (this.filter.search) {
        this.$emit("selectSearchMsg", item, this.total, index, this.filter);
      }
    },
    openModalImage(path) {
      this.path = path;
      this.$refs.ChatBoxModalImage.show();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep #sidebar-filter-history {
  background-color: rgba(70, 70, 70, 0.5) !important;
}
::v-deep .btn-search {
  background-color: #832abf !important;
  border-color: #832abf;
  color: #fff;
}
::v-deep .btn-import {
  background-color: #fff !important;
  border-color: #832abf;
  color: #832abf;
  border-radius: 33px;
  padding: 2px 7px;
  margin-top: 5px;
  font-size: 12px;
  .bg-icon {
    color: #832abf;
  }
}
.warp-history {
  position: fixed;
  top: 0;
  right: 0;
  height: 100dvh;
  z-index: 1040;
  overflow-x: hidden;
  width: 0%;
  .sidepanel {
    position: relative;
    right: -400px;
    width: 400px;
    height: 100dvh;
    background-color: rgb(255, 255, 255);
    color: #707070;
    border-left: 1px solid #b3afaf6e;
    margin-left: auto;
    transition: 0.5s;
    .closebtn {
      padding: 8px 0 8px 8px;
      text-decoration: none;
      color: #707070;
      display: block;
      transition: 0.3s;
      font-size: 23px;
    }
    .btn-clear {
      text-decoration: none;
      color: #707070;
      display: block;
      transition: 0.3s;
      font-size: 23px;
    }
    .title-side {
      font-size: 16px;
    }
    .text-total {
      color: #9c9c9c;
      font-size: 12px;
    }
    .filter-form {
      min-height: calc(100dvh - 60px);
    }
    .filter-date {
      margin-bottom: 15px;
      label {
        color: #575757;
        font-size: 14px;
        margin-bottom: 2px;
      }
    }
    .icon-search {
      position: absolute;
      top: 7px;
      right: 15px;
      color: #768192;
    }
    .chat-search-result {
      background-color: #f6f6f6;
      margin-top: 0.5rem;
      .title {
        background-color: #fff;
        display: flex !important;
        display: -ms-flexbox !important;
        justify-content: space-between !important;
        -ms-flex-pack: justify !important;
        align-items: center !important;
        -ms-flex-align: center !important;
        padding: 0 1rem 0.5rem 1rem;
      }
      .results {
        height: calc(100dvh - 334px + 61px - 14px);
        overflow: hidden;
        overflow-y: auto;
        padding-top: 1rem;
      }
      .results::-webkit-scrollbar {
        width: 0.35em;
      }

      .results::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(177, 175, 175, 0.3);
      }

      .results::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        outline: 1px solid #c1c1c1;
      }
      .msg-row {
        padding: 0 1rem;
        cursor: pointer;
        .border-bottom-custom {
          border-bottom: 1px solid #d8dbe0 !important;
          margin-top: 0.75rem;
          margin-bottom: 0.75rem;
        }
        .name {
          margin-bottom: 0;
          font-size: 14px;
          color: #000000;
          font-weight: 600;
        }
        .time {
          color: #bfbfbf;
          font-size: 14px;
        }
      }
    }
  }
  .reload-chat,
  .loading-prepare {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
}
.warp-history.show {
  width: 100%;
  .sidepanel {
    right: 0;
  }
}
::v-deep mark {
  background-color: #ffc107 !important;
}
::v-deep .form-control:disabled,
.form-control[readonly] {
  background-color: #e9e9e9;
  opacity: 1;
  border: none;
  color: #000;
  overflow-y: hidden !important;
}
::v-deep .dropdown-import-chat {
  ul {
    padding: 0;
  }
  .dropdown-toggle::after {
    margin-left: 5px;
  }
}
::v-deep .input-with-btn-icon {
  .custom-input {
    border-radius: 0.25rem 0px 0px 0.25rem !important;
    border-right: 0 !important;
  }
  .custom-input:focus {
    border-color: #dbdbdb;
  }
  .btn-icon {
    border-radius: 0px 0.25rem 0.25rem 0px;
  }
  .btn-icon:hover,
  .btn-icon:active {
    background-color: transparent;
  }
}
.error-datetime {
  color: #e55353;
  font-size: 11px;
  position: absolute;
  bottom: -2px;
}
.sticky-top {
  z-index: 500;
}

.msg_cotainer {
  margin-top: auto;
  margin-bottom: auto;
  position: relative;
  font-size: 14px;
}
.msg_cotainer_img {
  margin-top: auto;
  margin-bottom: auto;
  // margin-left: auto;
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: 50%;
  div {
    display: flex;
    width: 100%;
    flex-flow: column;
  }
  .img_upload {
    margin-right: auto;
    height: auto;
    max-height: 20rem;
    width: 100%;
    max-width: 30rem;
    .img_upload-display {
      width: 100%;
      padding-bottom: 56.25%;
      background-size: contain;
      background-position: top left;
      background-repeat: no-repeat;
      background-color: inherit !important;
    }
  }
  .msg_time {
    padding-left: 10px;
  }
}
@media (max-width: 767.98px) {
  .warp-history {
    .sidepanel {
      width: 100%;
      right: -100%;
      .chat-search-result {
        .results {
          height: calc(100dvh - 324px + 51px - 15px);
        }
      }
    }
  }
  .warp-history.show {
    .sidepanel {
      right: 0;
    }
  }
}
</style>
